function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AssetBundles } from "./AssetBundles";
import { Resource } from "./Resource";
export var ResourceLoader = /*#__PURE__*/function () {
  function ResourceLoader(schema) {
    _classCallCheck(this, ResourceLoader);
    _defineProperty(this, "schema", void 0);
    this.schema = schema;
  }
  _createClass(ResourceLoader, [{
    key: "test",
    value: function test(uri) {
      return uri.startsWith(this.schema);
    }
  }]);
  return ResourceLoader;
}();
export var AssetResource = /*#__PURE__*/function (_Resource) {
  _inherits(AssetResource, _Resource);
  var _super = _createSuper(AssetResource);
  function AssetResource(asset, loadFn) {
    var _this;
    _classCallCheck(this, AssetResource);
    _this = _super.call(this, {
      load: loadFn
    });
    _this.asset = asset;
    return _this;
  }
  return _createClass(AssetResource);
}(Resource);
export var AssetResourceLoader = /*#__PURE__*/function (_ResourceLoader) {
  _inherits(AssetResourceLoader, _ResourceLoader);
  var _super2 = _createSuper(AssetResourceLoader);
  function AssetResourceLoader(bundles, loaders) {
    var _this2;
    _classCallCheck(this, AssetResourceLoader);
    _this2 = _super2.call(this, "asset:");
    _defineProperty(_assertThisInitialized(_this2), "bundles", void 0);
    _defineProperty(_assertThisInitialized(_this2), "loaders", []);
    if (Array.isArray(bundles)) {
      bundles = new AssetBundles(bundles);
    }
    _this2.bundles = bundles;
    _this2.loaders = loaders;
    return _this2;
  }
  _createClass(AssetResourceLoader, [{
    key: "_load",
    value: function _load(asset, params) {
      var loader = this.loaders.find(function (loader) {
        return loader.test(asset);
      });
      if (!loader) {
        console.log("asset id", asset.id, "asset: ", asset, "unable load");
        throw new Error("asset: ".concat(asset.id, " loader is not support"));
      }
      return loader.load(asset, params);
    }
  }, {
    key: "load",
    value: function load(uri) {
      var _this3 = this;
      var assetUri = uri.substring(6);
      var delimiterIndex = assetUri.indexOf('?');
      var assetId = assetUri;
      var params = {};
      if (!!~delimiterIndex) {
        assetId = assetUri.substring(0, delimiterIndex);
        var search = assetUri.substring(delimiterIndex);
        if (search) {
          new URLSearchParams(search).forEach(function (value, key) {
            params[key] = value;
          });
        }
      }
      var asset = this.bundles.select(assetId);
      if (!asset) {
        throw new Error("unable find asset, assetId: ".concat(assetId));
      }
      return new AssetResource(asset, function () {
        return _this3._load(asset, params);
      });
    }
  }]);
  return AssetResourceLoader;
}(ResourceLoader);